// Hook : source de vérité pour la langue active.
// Lit l'URL (et non un state global) pour rester aligné avec le SEO et permettre
// un partage de lien direct dans la bonne langue.

import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { detectLangFromPath, type Lang } from "./routes";

export function useLang(): Lang {
  const { pathname } = useLocation();
  const lang = detectLangFromPath(pathname);
  const { i18n } = useTranslation();

  // Synchronise i18next avec l'URL si l'utilisateur navigue
  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return lang;
}
